import { ComponentType } from "react";
import {
  FiAward,
  FiCalendar,
  FiHeart,
  FiStar,
  FiTrendingUp,
  FiUsers,
} from "react-icons/fi";
import AppLayout from "../../../../shared/components/AppLayout";
import teamPhoto from "../../../../assets/images/about/team.jpg";
import { siteTexts } from "../../../../shared/i18n/siteTexts";
import "./AboutPage.css";

type IconLike = ComponentType<Record<string, unknown>>;

const HeartIcon = FiHeart as unknown as IconLike;
const UsersIcon = FiUsers as unknown as IconLike;
const AwardIcon = FiAward as unknown as IconLike;
const TrendingUpIcon = FiTrendingUp as unknown as IconLike;
const StarIcon = FiStar as unknown as IconLike;
const CalendarIcon = FiCalendar as unknown as IconLike;

const paragraphIcons = [
  HeartIcon,
  UsersIcon,
  AwardIcon,
  TrendingUpIcon,
  StarIcon,
];

const aboutCardMeta = [
  { icon: AwardIcon, tone: "pink" },
  { icon: CalendarIcon, tone: "blue" },
  { icon: UsersIcon, tone: "purple" },
  { icon: StarIcon, tone: "pink" },
];

export default function AboutPage() {
  const aboutParagraphs = siteTexts.home.aboutParagraphs;
  const storyTitles =
    siteTexts.about.storyTitles?.length === aboutParagraphs.length
      ? siteTexts.about.storyTitles
      : siteTexts.about.storyTitles;

  return (
    <AppLayout
      title={<span className="about-page-title">{siteTexts.home.aboutFallbackTitle}</span>}
      subtitle={siteTexts.about.subtitle}
    >
      <div className="about-page-shell">
        <section className="about-main-grid" aria-label={siteTexts.about.storyAriaLabel}>
          <figure className="about-photo-card">
            <div className="about-photo-frame">
              <img src={teamPhoto} alt={siteTexts.about.alt.team} />
            </div>
            <figcaption>
              <UsersIcon />
              <span>{siteTexts.about.captions.team}</span>
            </figcaption>
          </figure>

          <div className="about-story-list">
            {aboutParagraphs.map((paragraph, index) => {
              const ParagraphIcon = paragraphIcons[index] || StarIcon;

              return (
                <article className="about-story-item" key={`about-paragraph-${index}`}>
                  <span className="about-story-icon" aria-hidden="true">
                    <ParagraphIcon />
                  </span>
                  <div className="about-story-copy">
                    <h2>{storyTitles[index] || siteTexts.home.aboutFallbackTitle}</h2>
                    <p>{paragraph}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        <section className="about-feature-cards" aria-label={siteTexts.about.featuresAriaLabel}>
          {siteTexts.about.featureCards.map((card, index) => {
            const meta = aboutCardMeta[index] || aboutCardMeta[0];
            const CardIcon = meta.icon;

            return (
              <article
                key={card.title}
                className={`about-feature-card about-feature-card--${meta.tone}`}
              >
                <span className="about-feature-icon" aria-hidden="true">
                  <CardIcon />
                </span>
                <div>
                  <h2>{card.title}</h2>
                  <p>{card.text}</p>
                </div>
              </article>
            );
          })}
        </section>
      </div>
    </AppLayout>
  );
}
